var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 148,
    viewBox: "0 0 184 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_461_4527)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 21,
    width: 102,
    height: 66,
    rx: 24,
    fill: "#006FCF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 20.5,
    width: 103,
    height: 67,
    rx: 24.5,
    stroke: "#D6DCE5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.039 32.9497H134.596L130.183 45.6693L125.578 32.9497H116.944V52.755L108.117 32.9497H101.018L92.1916 53.185H98.3314L100.058 49.1381H109.268L110.995 53.185H122.508V39.1164L127.688 53.185H132.485L137.666 39.1164V53.185H143.039V56.2683H135.939L130.183 62.6281L124.235 56.2683H99.8666V76.5036H124.043L129.991 69.9514L135.939 76.5036H143.039V79.0085H134.596L129.991 73.9982L125.386 79.0085H96.7967V55.8828H87.5864L99.099 29.8657H110.228L114.257 38.7309V29.8657H128.072L130.375 36.611L132.677 29.8657H143.039V32.9497ZM143.039 60.7007L137.858 66.2895L143.039 71.8783V76.5036L133.637 66.2895L143.039 56.2683V60.7007ZM116.944 76.5036V71.6858H105.431V68.6024H116.751V63.9771H105.431V60.8937H116.944V56.2683L126.537 66.2895L116.944 76.5036ZM101.785 44.7052L104.472 38.153L107.158 44.7052H101.785Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_461_4527",
    x: 0,
    y: 0,
    width: 184,
    height: 148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_461_4527"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_461_4527",
    result: "effect2_dropShadow_461_4527"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_461_4527",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpress);
export default __webpack_public_path__ + "static/media/Express.f5f49692ff12829e31b20714eaa51e04.svg";
export { ForwardRef as ReactComponent };